module.exports = __webpack_public_path__ + "static/media/Kristin Payne Headshot.8751e2b8.jpeg";